import firebase from 'firebase/compat/app';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from './useAuth';
import { useLoan } from '../stores/store';
import useHistory from './useHistory';

let createdAnon = false;

export function useUser() {
  const [user, setUser] = useState<null | firebase.User>(null);
  const [, forceRender] = useState(0);
  const auth = useAuth();
  const loanStore = useLoan();
  const history = useHistory();
  const prevIsAnonymousRef = useRef<boolean | null>(null);

  useEffect(() => {
    const unsubscribe = auth.onIdTokenChanged((cuser: firebase.User | null) => {
      if (!cuser && history.location.pathname !== '/logout') {
        if (createdAnon) return;
        createdAnon = true;
        auth.signInAnonymously();
        loanStore.setUserAdmin(false);
      } else {
        setUser(cuser);
        const currentIsAnonymous = cuser?.isAnonymous ?? null;
        if (currentIsAnonymous !== prevIsAnonymousRef.current) {
          prevIsAnonymousRef.current = currentIsAnonymous;
          forceRender((c) => c + 1);
        }
        cuser?.getIdTokenResult().then((value) => {
          loanStore.setUserAdmin(value.claims.admin === true); // may be undefined
        });
      }
    });
    return unsubscribe;
  }, [auth, loanStore, history.location.pathname]);

  return user;
}

export function disableAnonCreation() {
  createdAnon = true;
}
